import * as React from 'react';
import { DefaultView, defaultView } from '../HOC';
import { WithStyles, Theme, createStyles, withStyles, Paper, Table, TableHead, TableRow, TableCell, TableBody, Fab, TableFooter, Dialog, DialogContent, Typography, FormControl, TextField, InputLabel, Select, Input, MenuItem, DialogActions, Button, CircularProgress, Tabs, Tab, IconButton, List, ListItem, ListItemText } from '@material-ui/core';
import { SubAccount, ClientsAPI, errorToString } from 'src/api';
import AddIcon from '@material-ui/icons/Add';
import { CloseOutlined, InsertPhotoOutlined } from '@material-ui/icons'
import strings from 'src/strings';
import { ReportFrequency } from 'src/api/models/sub_account';
import Datasource from './Datasource';
import ConnectDatasource from './ConnectDatasource';
interface ClientPageProps extends DefaultView<true>, WithStyles<typeof styles> {

}
interface ClientPageState {
    clients: SubAccount[]
    loading: boolean,
    newClient?: SubAccount,
    selectedClient?: SubAccount
    tab: number
}
class ClientPage extends React.Component<ClientPageProps, ClientPageState> {

    constructor(props: ClientPageProps) {
        super(props)
        this.state = {
            clients: [],
            loading: false,
            tab: 0
        }
        this.handleClientChange = this.handleClientChange.bind(this)
        this.submitClient = this.submitClient.bind(this)
        this.uploadLogo = this.uploadLogo.bind(this)
    }

    componentDidMount() {
        ClientsAPI.getClients().then(clients => {
            this.setState({
                loading: false, clients: clients.sort((cl1, cl2) => {
                    return cl2.created_at.getDate() - cl1.created_at.getDate()
                })
            })
        }).catch(err => {
            this.setState({ loading: false })
            errorToString(err).forEach(error => {
                this.props.showToast('error', error)
            })
        })
    }

    private deleteClient(client: SubAccount) {
        let selectedClient = this.state.selectedClient
        if (selectedClient && selectedClient.id == client.id) {
            selectedClient = undefined
        }
        this.setState({ loading: true, selectedClient: selectedClient })
        ClientsAPI.deleteClient(client).then(() => {
            this.setState({ loading: false, clients: this.state.clients.filter(c => c.id != client.id) })
        }).catch(err => {
            this.setState({ loading: false })
            errorToString(err).forEach(error => {
                this.props.showToast('error', error)
            })
        })
    }

    private submitClient() {
        if (!this.state.newClient!.name || this.state.newClient!.name.trim() == '') {
            this.props.showToast('error', strings.newClient_nameMissing)
            return
        }
        ClientsAPI.addClient(this.state.newClient!).then(client => {
            this.setState({ loading: false, clients: this.state.clients.concat(client), newClient: undefined })
        }).catch(err => {
            this.setState({ loading: false })
            errorToString(err).forEach(error => {
                this.props.showToast('error', error)
            })
        })
    }

    private uploadLogo(e: React.ChangeEvent<HTMLInputElement>) {
        if (e.target.files && e.target.files.length) {
            this.setState({ loading: true })
            const uploadingClient = this.state.selectedClient!
            ClientsAPI.uploadLogo(uploadingClient, e.target.files[0]).then(client => {
                let clients = this.state.clients
                let index = this.state.clients.findIndex(c => c.id == uploadingClient.id)
                clients[index] = client;
                this.setState({ loading: false, selectedClient: client, clients: clients })
            }).catch(err => {
                this.setState({ loading: false })
                errorToString(err).forEach(error => {
                    this.props.showToast('error', error)
                })
            })
            e.target.value = ''
        }
    }

    private handleClientChange(key: keyof SubAccount, keyPath: string = 'value') {
        return (value: React.ChangeEvent<any>) => {
            let m = this.state.newClient!
            m[key] = value.target[keyPath];
            this.setState({ newClient: m })
        }
    }

    public render() {
        const { classes } = this.props
        return <>
            <div className={classes.root}>
                <Paper className={classes.paper} style={{ flexGrow: 2 }}>
                    <Table className={classes.table}>
                        <TableHead>
                            <TableRow>
                                <TableCell>{strings.newClient_name}</TableCell>
                                <TableCell>{strings.newClient_logo}</TableCell>
                                <TableCell align="right">{strings.newClient_frequency}</TableCell>
                                <TableCell align="right">{strings.newClient_addedAt}</TableCell>
                            </TableRow>
                        </TableHead>
                        <TableBody>
                            {this.state.clients.map(client => (
                                <TableRow key={client.id} selected={this.state.selectedClient && this.state.selectedClient.id == client.id}
                                    onClick={() => this.setState({ selectedClient: client })}>
                                    <TableCell component="th" scope="row">
                                        {client.name}
                                    </TableCell>
                                    <TableCell>
                                        {client.logo_url && <img src={client.logo_url} className={classes.tableLogo} />}
                                        {!client.logo_url && <InsertPhotoOutlined />}
                                    </TableCell>
                                    <TableCell align="right">{client.report_frequency}</TableCell>
                                    <TableCell align="right">{client.created_at.toLocaleDateString()}</TableCell>
                                </TableRow>
                            ))}
                        </TableBody>
                        <TableFooter>
                            <TableRow>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell></TableCell>
                                <TableCell align="right">
                                    <Fab color="primary" aria-label="Add" className={classes.fab} onClick={(e) => this.setState({ newClient: new SubAccount() })}>
                                        <AddIcon />
                                    </Fab>
                                </TableCell>
                            </TableRow>
                        </TableFooter>
                    </Table>
                </Paper>
                {true && <div className={this.state.selectedClient ? '' : classes.hidden} style={{ width: '30%' }}>
                    <Typography variant="h4" style={{ textAlign: 'center' }}>
                        {this.state.selectedClient ? this.state.selectedClient!.name : ''}
                    </Typography>
                    <Tabs value={this.state.tab} onChange={(_, value) => { value != 3 && this.setState({ tab: value }) }}
                        className={classes.tabs}>
                        <Tab label={strings.client_runReports} />
                        <Tab label={strings.client_connectDatasource} />
                        <Tab label={strings.client_admin} />
                        <Tab fullWidth={false} className={classes.closeTab}
                            icon={<CloseOutlined />} onClick={(e) => {
                                e.stopPropagation()
                                this.setState({ selectedClient: undefined })
                            }}></Tab>
                    </Tabs>
                    <div className={classes.tabContent}>
                        {this.state.tab == 1 && <div>
                            <ConnectDatasource client={this.state.selectedClient!} />
                        </div>
                        }
                        {this.state.tab == 2 && <div>
                            <List>
                                <ListItem>
                                    <ListItemText primary={strings.client_uploadAction} secondary={strings.client_uploadLogo} />
                                    <Button variant='outlined' color='primary' className={classes.actionButton} disabled={this.state.loading}
                                        onClick={(e) => {
                                            (this.refs.uploadInput as HTMLInputElement).click()
                                        }}>
                                        {strings.client_uploadAction}
                                    </Button>
                                </ListItem>
                                <ListItem>
                                    <ListItemText primary={strings.client_deleteAction} secondary={strings.client_deleteDescription} />
                                    <Button variant='outlined' color='secondary' className={classes.actionButton} disabled={this.state.loading}
                                        onClick={(e) => {
                                            if (confirm(strings.client_deleteAreYouSure)) {
                                                this.deleteClient(this.state.selectedClient!)
                                            }
                                        }}>
                                        {strings.client_deleteAction}
                                    </Button>
                                </ListItem>
                            </List>
                            <input ref="uploadInput" type='file' hidden accept="image/*" onChange={this.uploadLogo} />
                        </div>}
                    </div>
                </div>}
            </div>
            <Dialog open={!!this.state.newClient} onClose={() => this.setState({ newClient: undefined })}>
                {this.state.newClient && <div className={classes.dialogContainer}>
                    <DialogContent>
                        <Typography variant="h5">
                            New Client
                        </Typography>
                        <FormControl fullWidth className={this.props.classes.formControlPadding} required>
                            <TextField value={this.state.newClient!.name} onChange={this.handleClientChange('name')} label={strings.newClient_name} required />
                        </FormControl>
                        <FormControl className={this.props.classes.formControlPadding} fullWidth>
                            <InputLabel htmlFor="type-select">{strings.newClient_frequency}</InputLabel>
                            <Select
                                value={this.state.newClient!.report_frequency || ''}
                                onChange={this.handleClientChange('report_frequency')}
                                fullWidth
                                input={<Input id="type-select" />}>
                                {Object.keys(ReportFrequency).map(k => {
                                    return <MenuItem key={k} value={ReportFrequency[k]}>{ReportFrequency[k]}</MenuItem>
                                })}
                            </Select>
                        </FormControl>


                    </DialogContent>
                    <DialogActions>
                        <div className={this.props.classes.formButtons}>
                            <Button variant='outlined' color='secondary' disabled={this.state.loading} onClick={this.submitClient}>
                                {this.state.loading && <CircularProgress color='inherit' variant={'indeterminate'} size={24} />}
                                {!this.state.loading && strings.done}
                            </Button>
                        </div>
                    </DialogActions>
                </div>}
                {!this.state.newClient && <div />}
            </Dialog>
        </>
    }
}

const styles = (theme: Theme) => createStyles({
    paper: {
        marginRight: theme.spacing(2),
        marginTop: theme.spacing()
    },
    actionButton: {
        float: 'right'
    },
    hidden: {
        display: 'none',
        WebkitTransition: 'width 1s ease-in-out',
        MozTransition: 'width 1s ease-in-out',
        OTransition: 'width 1s ease-in-out',
        transition: 'width 1s ease-in-out'
    },
    tabs: {
        marginLeft: theme.spacing(2),
        marginBottom: theme.spacing(2),
        marginTop: theme.spacing(),
        marginRight: theme.spacing(2),
    },
    closeTab: {
        paddingRight: theme.spacing(2),
        marginLeft: 'auto',
        width: '40px',
        minWidth: 'unset'
    },
    tabContent: {
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
    },
    tableLogo: {
        maxHeight: '40px'
    },
    root: {
        width: '100%',
        display: 'flex',
        flexDirection: 'row',
        height: 'calc(100% - ' + (80 + theme.spacing(2)) + 'px)',
    },
    'root:first-child': {
        width: '100%'
    },
    table: {
        minWidth: 700,
    },
    fab: {
        margin: theme.spacing(),
        float: 'right'
    },
    formButtons: {
        paddingTop: 20,
        display: 'flex',
        justifyContent: 'flex-end',
        marginTop: 'auto'
    },
    formControlPadding: {
        paddingTop: theme.spacing()
    },
    dialogContainer: {
        minWidth: 400
    }
});

export default defaultView(withStyles(styles)(ClientPage), true) as React.ComponentClass


// WEBPACK FOOTER //
// ./src/components/Client/Client.tsx